<template>
  <v-container class="device-vehicle-info">
    <FormRow 
      label="Mileage"
      :input-payload="mileage"
      :is-number="true"
      @parseNewVAl="parseNewVal($event, 'mileage', 'Vehicle Info / Mileage')"
    />
    <div class="mileage-row">
      <FormRow 
        label="Update mileage"
        :input-payload="mileageSettings"
        :check-box="true"
        @parseNewVAl="handleMileageSettings($event)"
      />
      <span 
        v-if="mileageSettings"
        class="mileage-warn"
      >
        Warning: The base mileage for all devices receiving this config update will be reset to this value!
      </span>
    </div>
    
    <FormRow 
      label="Distance Unit"
      :input-payload="distanceUnit"
      :dropdown="true"
      :options="units"
      @parseNewVAl="parseNewVal($event, 'distanceUnit', 'Vehicle Info / Distance Unit')"
    />
  </v-container>
</template>

<script>

import FormRow from '../components/FormRow.vue';

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

import { Logger } from "aws-amplify";
const logger = new Logger("device config / vehicle info");

export default {
  name: 'VehicleInfo',
  components: {
    FormRow
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    },
    batch: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      units: [
        {
          xml: 'km',
          label: 'KM'
        },
        {
          xml: 'miles',
          label: 'Miles'
        }
      ],
      selectedUnit: '',
      mileage: 0,
      mileageSettings: false
    }
  },
  computed: {
    parsedMileage() {
      let mileage = parseInt(this.config.device_config.system[0].mileage[0]);

      return mileage;
    },
    distanceUnit() {
      return this.config.device_config.system[0].distanceUnit[0];
    }
  },
  mounted() {
    this.mapData();
  },
  methods: {
    mapData() {
      this.selectedUnit = this.distanceUnit
      this.mileage = this.convertMileage(this.parsedMileage);
    },
    convertMileage(mileage) {
      if (this.selectedUnit == 'km') {
        return Math.round(mileage / 1000);
      } 
      else if (this.selectedUnit == 'miles') {
        return Math.round(mileage  * 0.000621371);
      }
    },
    handleMileageSettings(state) {
      this.mileageSettings = state;

      if(this.mileageSettings) {
        logger.info('update ', this.mileage)
        this.parseNewVal(this.mileage, 'mileage', 'Vehicle Info / Update Mileage')
      }
      else {
        logger.info('ignore : ')
        this.updateConfig(-1, 'mileage', 'Vehicle Info / Update Mileage');
      }
    },
    parseNewVal(val, id, label) {
      let payloadMileage = 0;
 
      if (id == 'distanceUnit') {
        // Units have changed so we need to update the UI with converted distance
        if(val != this.selectedUnit) {
          let currentMileageMeters = this.selectedUnit.toLowerCase() == 'km' ? this.mileage * 1000 : Math.round(this.mileage * 1609.34);

          // Only apply new mileage if user has enabled checkbox
          if (this.mileageSettings) {
            this.mileage = this.convertMetersToDisplayUnits(val, currentMileageMeters);
            this.updateConfig(currentMileageMeters, 'mileage', label);
          }
        }
  
        this.selectedUnit = val.toLowerCase();
        this.updateConfig(this.selectedUnit, id, label);
      }

      if (id == 'mileage') {
        this.mileage = parseInt(val);
        // Only apply new mileage if user has enabled checkbox
        if (this.mileageSettings) {
          payloadMileage = this.convertDistanceToMeters(this.selectedUnit, val);
          this.updateConfig(payloadMileage, id, label);
        }
        
      }
    },
    updateConfig(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, [this.units]),
        key: this.configPropMapper(id),
        label: label
      }

      this.$emit('settingsUpdated', payload, this.units);
    },
    convertDistanceToMeters(unit, distance) {
      // convert km to meters
      if (unit.toLowerCase() == 'km') {
        return Math.round(distance * 1000);
      } 
      // convert miles to meters
      else if (unit.toLowerCase() == 'miles') {
        return Math.round(distance * 1609.34);
      }
    },
    convertMetersToDisplayUnits(unit, distance) {
      // convert km to meters
      if (unit.toLowerCase() == 'km') {
        logger.info('km returned',distance, Math.round(distance / 1000))
        return Math.round(distance / 1000);
      } 
      else if (unit.toLowerCase() == 'miles') {
        logger.info('miles returned', distance, Math.round(distance  * 0.000621371))
        return Math.round(distance  * 0.000621371);
      }
    },
    configPropMapper(key) {
      let map = {
        'mileage': 'device_config.system[0].mileage[0]',
        'distanceUnit': 'device_config.system[0].distanceUnit[0]'
      }

      return map[key];
    }
  }
}
</script>

<style lang="scss" scoped>
.mileage-row {
  position: relative;

  .mileage-warn {
    position: absolute;
    top: -2px;
    right: 70px;
    color: red;
    width: 360px;
  }
}
</style>